import { Formik } from 'formik';

import { AdvancedSearchFormAB } from './AdvancedSearchFormAB/AdvancedSearchFormAB';

import type { ReactElement } from 'react';
import type { SearchFilters } from '~/common/types/search';

type Props = {
  currentValues: SearchFilters;
  isLoading: boolean;
  onFilterSubmit: (searchFilters: SearchFilters) => void;
  serviceSlug: string;
  sittersCount: number;
};

const AdvancedSearch = ({
  currentValues,
  isLoading,
  onFilterSubmit,
  serviceSlug,
  sittersCount,
}: Props): ReactElement => {
  const handleSubmit = (values: SearchFilters): void => {
    onFilterSubmit({
      ...currentValues,
      bookingType: values.bookingType,
      chronology: {
        startDate: values.chronology.startDate,
        endDate: values.chronology.endDate,
        scheduledDates: values.chronology.scheduledDates,
        weekDays: values.chronology.weekDays,
        rwbStartDate: values.chronology.rwbStartDate,
      },
      location: values.location,
      petTypes: values.petTypes,
      service: {
        type: values.service.type,
        quantity: 0,
      },
      sort: values.sort,
      advancedFilters: values.advancedFilters,
    });
  };

  return (
    <Formik enableReinitialize={true} initialValues={currentValues} onSubmit={handleSubmit}>
      <AdvancedSearchFormAB
        currentValues={currentValues}
        isLoading={isLoading}
        serviceSlug={serviceSlug}
        sittersCount={sittersCount}
      />
    </Formik>
  );
};

export { AdvancedSearch };
